import React, {ButtonHTMLAttributes, DetailedHTMLProps} from "react";
import Loader from "./Loader";


export interface ButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    buttonStyle?: ButtonStyle;
    buttonSize?: ButtonSize;
    isLoading?: boolean;
}

export enum ButtonStyle {
    DEFAULT,
    LINK,
}

export enum ButtonSize {
    DEFAULT,
    SMALL,
    LARGE,
    FULL,
}

export const Button = (props: ButtonProps) => {
    const {buttonStyle, buttonSize, isLoading, disabled, ...otherProps} = props;

    let sizeClassName = "";
    switch (buttonSize) {
        case ButtonSize.FULL:
            sizeClassName = "w-full"
            break;
        case ButtonSize.LARGE:
            sizeClassName = "w-60"
            break;
        case ButtonSize.SMALL:
            sizeClassName = "w-40"
            break;
        default:
            sizeClassName = ""
            break;
    }

    const commonClassName = `font-roboto flex justify-center gap-x-2 items-center ${sizeClassName}`;
    let className = " bg-gradient-to-r from-blue-gradient--left to-blue-gradient--right " +
        "rounded-full text-white font-medium uppercase px-8 py-3 " +
        "disabled:bg-none disabled:opacity-75 disabled:!bg-grey--400 "
    if (!!props.buttonStyle && props.buttonStyle === ButtonStyle.LINK) {
        className = "bg-inherit text-blue"
    }

    return (
        <button
            {...otherProps}
            disabled={!!disabled}
            className={commonClassName + " " + className + " " + props.className}
        >
            {isLoading &&
                <div className={"h-5 w-5"}>
                    <Loader />
                </div>
            }
            {props.children}
        </button>
    )
}